export default {
  listFolderReceiveMail: state => state.listFolderReceiveMail,
  listRuleReceiveMail: state => state.listRuleReceiveMail,
}